import { Component, Input } from '@angular/core';
import { Survey } from '../../models/survey.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyService } from '../../services/survey.service';
import { UtilService } from '../../services/util.service';
import moment from 'moment';
import { NeighborhoodService } from '../../services/neighborhood.service';

@Component({
  selector: 'app-survey-modal',
  templateUrl: './survey-modal.component.html',
  styleUrl: './survey-modal.component.scss'
})
export class SurveyModalComponent {

  @Input() neighborhoodId!: string;
  @Input() survey?: Survey;

  public dataForm: DataFormModel = {
    title: {
      value: '',
      type: 'text',
      label: 'Título de la encuesta',
      required: true,
      requiredMessage: 'Por favor, ingrese el título de la encuesta',
      validators: [Validators.required]
    },
    content: {
      value: '',
      type: 'textarea',
      label: 'Resumen u objetivo de la encuesta',
      required: true,
      requiredMessage: 'Por favor, ingrese el resumen u objetivo de la encuesta',
      validators: [Validators.required]
    },
    dueDate: {
      value: '',
      type: 'datetime',
      label: 'Fecha límite',
      required: true,
      requiredMessage: 'Por favor, seleccione la fecha límite',
      validators: [Validators.required]
    },
    status: {
      value: false,
      type: 'switch',
      label: 'Publicar',
      required: false,
      validators: []
    }
  };

  public formSurvey!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public neighborhoodService: NeighborhoodService,
    public surveyService: SurveyService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formSurvey.controls;
  }

  async loadData() {
    this.loading = true;

    if (this.survey) {
      this.dataForm = { ...this.dataForm };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.survey!) {
          const standardKey = key as keyof typeof this.survey;
          
          if(this.dataForm[key].type === 'datetime') {
            this.dataForm[key].value = moment(
              this.survey![standardKey]?.toString()
            ).add(
              this.neighborhoodService.currentNeighborhood?.timeZone,
              'hours'
            ).toDate();
          } else {
            this.dataForm[key].value = this.survey![standardKey];
          }

        }
      }
    }

    this.formSurvey = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formSurvey.invalid) {
      return;
    }

    console.log(this.formSurvey.value);

    this.formSurvey.value.dueDate = moment(
      this.formSurvey.value.dueDate
    ).format('YYYY-MM-DD HH:mm');

    if (this.survey) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.surveyService.create(
      this.neighborhoodId,
      this.formSurvey.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

  async update() {
    this.formSurvey.value.surveyId = this.survey!.surveyId;
    this.formSurvey.value.neighborhoodId = this.survey!.neighborhoodId;

    const flag = await this.surveyService.update(
      this.formSurvey.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
